import { Component } from '@angular/core';

@Component({
  selector: 'app-match-rm',
  templateUrl: './match-rm.component.html',
  styleUrls: ['./match-rm.component.css']
})
export class MatchRmComponent {
  

}
